import { render } from "./NewEmplacementModal.vue?vue&type=template&id=12ecabf4"
import script from "./NewEmplacementModal.vue?vue&type=script&lang=js"
export * from "./NewEmplacementModal.vue?vue&type=script&lang=js"

import "./NewEmplacementModal.vue?vue&type=style&index=0&id=12ecabf4&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__